import { RootState } from 'handlers';

export const getPaycheckSwitchData = ({ paycheckSwitchData }: RootState) => paycheckSwitchData;
